import { render, staticRenderFns } from "./CreateTokenButton.vue?vue&type=template&id=37addf82&"
import script from "./CreateTokenButton.vue?vue&type=script&lang=js&"
export * from "./CreateTokenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports